import { PaletteOptions, PaletteMode } from '@mui/material';
import { blue, green } from './colors';

export const illustration = (mode: PaletteMode): PaletteOptions['illustration'] => {
  return mode === 'light'
    ? {
        blue1: blue[100],
        blue2: blue[200],
        green1: green[100],
        green2: green[300],
      }
    : {
        blue1: blue[800],
        blue2: blue[700],
        green1: green[800],
        green2: green[600],
      };
};
